import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const DeckButton = ({ className, testid, short }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { downloadPitchDeck } = await import("../lib/pitchDeck");
      await downloadPitchDeck();
      toast.success("Pitch deck downloaded");
    } catch (e) {
      toast.error("Could not create the pitch deck");
    }
    setBusy(false);
  };
  return (
    <button type="button" className={className} onClick={run} disabled={busy} data-testid={testid}>
      {busy ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />}
      {busy ? "Building…" : short ? "Pitch Deck" : "Download Pitch Deck"}
    </button>
  );
};
